module.exports = __webpack_public_path__ + "img/US_GoldGatherRate_ua.0a20a4db.webp";